/**
 * Laravel local dev (PHP 8.5+) may prepend deprecation HTML before JSON bodies.
 * Axios then leaves response.data as a string; this extracts the JSON payload.
 */
export function parseApiPayload(data) {
  if (data == null || typeof data === 'object') return data;
  if (typeof data !== 'string') return data;

  const trimmed = data.trim();
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      return JSON.parse(trimmed);
    } catch {
      // fall through
    }
  }

  // PHP warnings are prepended — scan each "{" until JSON.parse succeeds.
  let start = data.indexOf('{');
  while (start !== -1) {
    try {
      return JSON.parse(data.slice(start));
    } catch {
      start = data.indexOf('{', start + 1);
    }
  }

  start = data.indexOf('[');
  while (start !== -1) {
    try {
      return JSON.parse(data.slice(start));
    } catch {
      start = data.indexOf('[', start + 1);
    }
  }

  return data;
}
